import React, { useMemo } from 'react';
import Moment from 'moment';

import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import PlayIcon from '@material-ui/icons/PlayArrow';

const useStyles = makeStyles(theme => ({
  root: {
    cursor: 'pointer',
    '&:hover $title': {
      color: theme.palette.secondary.main,
    },
    '& .active $title': {
      color: theme.palette.secondary.main,
    },
  },
  background: {
    position: 'relative',
    height: '0',
    backgroundColor: 'rgba(255, 255, 255, 0.25)',
    backgroundSize: 'cover',
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat',
    paddingBottom: '56.25%'
  },
  icon: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: '-12px',
    marginLeft: '-12px',
    color: 'rgba(255, 255, 255, 0.75)'
  },
  content: {
    minHeight: '60px'
  },
  title: {
    color: '#ccc',
    marginTop: theme.spacing(1)/2,
    marginBottom: theme.spacing(1)/2
  },
  paragraph: {
    color: '#ccc',
    fontSize: '0.8em',
    fontWeight: 400,
    margin: 0
  }
}));

export default (props) => {

  const setTimecode = (config) => {
    const seconds = Moment.duration(config.startTime).asSeconds();
    props.setCurrentTime(seconds);
  }

  const active = useMemo(() => {
    const startTime = Moment.duration(props.config.startTime).asSeconds();
    const endTime =  Moment.duration(props.config.endTime).asSeconds();
    if (startTime <= props.currentTime && props.currentTime <= endTime) {
      return 'active';
    }
    return '';
  }, [props.config, props.currentTime]);

  const chapter = props.config;
  const classes = useStyles();
  return (
    <Grid container direction="row" alignItems="center" spacing={3} className={classes.root} onClick={() => setTimecode(chapter)}>
      <Grid item xs={4}>
        <div className={classes.background} style={{backgroundImage: `url('${chapter.imageUrl}')`}}>
          <div className={classes.icon}><PlayIcon className={classes.play} /></div>
        </div>
      </Grid>
      <Grid item xs={8}>
        <div className={`${classes.content} ${active}`}>
          <h4 className={classes.title}>{chapter.title}</h4>
          <p className={classes.paragraph}>{chapter.description}</p>
        </div>
      </Grid>
    </Grid>
  );
};